var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 1.23047C13.3594 1.23047 12.6014 1.98841 7.72906 6.86078C2.85669 11.7332 1.23257 13.3573 1.23257 13.3573",
    stroke: "white",
    strokeWidth: 1.7201
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23047 1.23047C1.23047 1.23047 1.98841 1.98841 6.86078 6.86078C11.7332 11.7332 13.3573 13.3573 13.3573 13.3573",
    stroke: "white",
    strokeWidth: 1.7201
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLogo);
export default __webpack_public_path__ + "static/media/closeLogo.0a5d12634c13f6807e69575264746310.svg";
export { ForwardRef as ReactComponent };